import { useEffect } from "react";

export default function LiveConfirmDialog({ title, message, confirmLabel, cancelLabel, onConfirm, onCancel, confirmTestId, cancelTestId, testId, zClass = "z-[1960]" }: {
  /** Optional bold heading above the message (Web / Chat / Confirm dialog 4384:1961). */
  title?: string;
  message: string; confirmLabel: string; cancelLabel: string; onConfirm(): void; onCancel(): void; confirmTestId?: string;
  cancelTestId?: string;
  testId?: string;
  /** Stacking: above a z-2000 modal when it confirms something inside one. */
  zClass?: string;
}) {
  useEffect(() => {
    // Handled here: an Escape that cancels this dialog closes nothing under it.
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape" && !e.defaultPrevented) { e.preventDefault(); onCancel(); } };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onCancel]);
  return (
    <div data-testid={testId} data-confirm-dialog className={`fixed inset-0 ${zClass} flex items-center justify-center bg-black/40`} onClick={onCancel}>
      <div role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}
        className="w-[min(360px,calc(100vw-32px))] rounded-xl bg-[var(--bg-surface)] p-5 shadow-lg flex flex-col gap-4">
        {title ? (
          <div className="flex flex-col gap-1.5">
            <h2 className="text-base font-semibold text-[var(--foreground)]">{title}</h2>
            <p className="text-sm text-[var(--foreground-muted)]">{message}</p>
          </div>
        ) : (
          <p className="text-sm text-[var(--foreground)]">{message}</p>
        )}
        <div className="flex justify-end gap-2">
          <button type="button" autoFocus data-testid={cancelTestId} onClick={onCancel}
            className="h-9 px-4 rounded-full text-sm text-[var(--foreground)] hover:bg-[var(--bg-hover)]">{cancelLabel}</button>
          <button type="button" data-testid={confirmTestId} onClick={onConfirm}
            className="h-9 px-4 rounded-full text-sm bg-[var(--destructive)] text-white">{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
